import type { RefObject } from 'react';
import type { HeadingRef } from '../../../atoms/heading/Heading.data';
import type { TextRef } from '../../../atoms/text/Text.data';
import type { PrimaryButtonRef } from '../../../atoms/primary-button/PrimaryButton.data';
import { findTransitionController } from '../../../../util/core-transition-component';

interface ModernCreativityInfoItemRefs {
  elementRef?: RefObject<HTMLElement | null>;
  titleRef?: RefObject<HeadingRef | null>;
  categoryRef?: RefObject<HeadingRef | null>;
  descriptionRef?: RefObject<TextRef | null>;
  linkRef?: RefObject<PrimaryButtonRef | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, titleRef, descriptionRef, linkRef, categoryRef }: ModernCreativityInfoItemRefs,
): void {
  const title = findTransitionController(titleRef);
  const description = findTransitionController(descriptionRef);
  const link = findTransitionController(linkRef);
  const category = findTransitionController(categoryRef);

  if (elementRef?.current) {
    timeline.fromTo(
      elementRef.current,
      { pointerEvents: 'none' },
      { pointerEvents: 'all', duration: 0.01 },
      0,
    );
  }

  if (category) {
    timeline.add(category.getTimeline('in') as gsap.core.Timeline, 0);
  }

  if (title) {
    timeline.add(title.getTimeline('in') as gsap.core.Timeline, 0);
  }
  if (description) {
    timeline.add(description.getTimeline('in') as gsap.core.Timeline, 0.1);
  }
  if (link) {
    timeline.add(link.getTimeline('in') as gsap.core.Timeline, 0.2);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, descriptionRef, linkRef, categoryRef }: ModernCreativityInfoItemRefs,
): void {
  const title = findTransitionController(titleRef);
  const description = findTransitionController(descriptionRef);
  const link = findTransitionController(linkRef);
  const category = findTransitionController(categoryRef);

  if (category) {
    timeline.add(category.getTimeline('out') as gsap.core.Timeline, 0);
  }

  if (title) {
    timeline.add(title.getTimeline('out') as gsap.core.Timeline, 0);
  }
  if (description) {
    timeline.add(description.getTimeline('out') as gsap.core.Timeline, 0);
  }
  if (link) {
    timeline.add(link.getTimeline('out') as gsap.core.Timeline, 0);
  }
}
